// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronLeft48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronLeft48: FC<ChevronLeft48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M27.314 38.4 15.521 24 27.314 9.6l2.972 2.417L20.483 24l9.803 11.984-2.972 2.416Z" />
        </svg>
    );
};

export default ChevronLeft48;
